"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var applyLegacyPropertyDecorator;

exports.default = applyLegacyPropertyDecorator = function (proto, key, decorator) {
  var descriptor, nextDescriptor;
  descriptor = Object.getOwnPropertyDescriptor(proto, key);
  if (!descriptor || !descriptor.configurable) {
    throw new Error("applyLegacyDecorator: Prototype missing " + key + " or it is not configurable");
  }
  nextDescriptor = decorator(proto, key, descriptor) || descriptor;
  return Object.defineProperty(proto, key, nextDescriptor);
};